import React from 'react'
import {
	CardHeader,
	CardDescription,
	CardMeta,
	IconWrapper,
	CardMetaTags,
	CardMetaTagsContainer,
	CardActions,
	IconPreviewWrapper
} from './SlideoutDocumentCard.styled';

import { Card, Typography, Checkbox, Icon } from '@ann/web-components';

const SlideoutDocumentCard = ({ id, title, description, ownerName, version, lock, action = true, checked, onChange }) => {

	const handleToggleSelection = () => {
		onChange(!checked);
	}

	return (
		<Card style={{ height: 'fit-content', maxHeight: '100%' }}>
			<CardHeader>
				<Checkbox
					checked={checked || false}
					onChange={handleToggleSelection}
					size="medium"
				/>
				<Icon name="filePresent" size="small" />
				<Typography
					category="title"
					size="medium"
					weight="bold"
					onClick={handleToggleSelection}
					style={{ cursor: 'pointer' }}
				>
					{title}
				</Typography>
			</CardHeader>
			<CardDescription>
				<Typography category="body" size="medium" weight="regular">{description}</Typography>
			</CardDescription>
			<CardMeta>
				<CardMetaTagsContainer>
					<CardMetaTags>
						<IconWrapper>
							<Icon name="group" size="small" />
						</IconWrapper>
						<Typography category="body" size="small" weight="regular">{ownerName}</Typography>
					</CardMetaTags>
					<CardMetaTags>
						<IconWrapper>
							<Icon name="lastUpdated" size="small" />
						</IconWrapper>
						<Typography category="body" size="small" weight="regular">{version}</Typography>
					</CardMetaTags>
					<CardMetaTags>
						<IconWrapper>
							<Icon name="lock" size="small" />
						</IconWrapper>
						<Typography category="body" size="small" weight="regular">{lock}</Typography>
					</CardMetaTags>
				</CardMetaTagsContainer>
			</CardMeta>
			{action && (
				<CardActions>
					{/* <IconPreviewWrapper>
						<Icon name="arrowRight" size="medium"/>
					</IconPreviewWrapper>*/}
				</CardActions>
			)}
		</Card>
	)
}

export default SlideoutDocumentCard
